// extracted by css-extract-rspack-plugin
export default {"confirm":"WithdrawModal__confirm--RpmR4"};